import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import useRemoteDomain from "../../../../hooks/queryResults/remote/useRemoteDomain";
import useRemotePull from "../../../../hooks/queryResults/remote/useRemotePull";
import useRemoteSource from "../../../../hooks/queryResults/remote/useRemoteSource";
import useRemoteTemplate from "../../../../hooks/queryResults/remote/useRemoteTemplate";
import Util from "../../../../util/util";
import Table from "../../../layout/Table";
import TimeAgo from "../../../ui/TimeAgo";

export default function AdminRemotePull() {
  const domain = useRemoteDomain();
  const template = useRemoteTemplate();
  const source = useRemoteSource();
  const pull = useRemotePull();

  const pullColumns = useMemo(
    () => [
      { Header: "Phase", accessor: "phase" },
      { Header: "Progress", accessor: "progress", className: "left" },
      { Header: "Started", accessor: "started" },
      { Header: "Ended", accessor: "ended" },
      { Header: "Took", accessor: "took" },
      { Header: "Num Errors", accessor: "numErrors" },
      {
        Header: "Errors",
        accessor: "errors",
        className: "left",
        style: { maxWidth: "15rem" },
      },
    ],
    []
  );

  const getPullData = (pull) => {
    const data = [];
    if (!pull) return data;
    ["all", "fetch", "parse", "check", "add", "compare"].forEach(
      (phaseName) => {
        const phase = pull[phaseName];
        console.log("errors", phase.errors);
        data.push({
          phase: phaseName,
          progress: (
            <>
              {Util.getProgressIcon(phase.progress)} {phase.progress}
            </>
          ),
          started: (
            <TimeAgo date={phase.startDate} includeFractionalSeconds={true} />
          ),
          ended: (
            <TimeAgo date={phase.endDate} includeFractionalSeconds={true} />
          ),
          took: Util.formatTimeInSeconds(phase.took),
          numErrors: phase.numErrors,
          errors: (
            <>
              {phase.errors.map((err) => {
                const fullErr = JSON.stringify(err);
                return (
                  <p>
                    <span title={fullErr}>{err.message}</span>
                  </p>
                );
              })}
            </>
          ),
        });
      }
    );
    return data;
  };

  const pullData = useMemo(() => getPullData(pull), [pull]);

  if (source && template && domain && pull) {
    console.log(source);
    return (
      <>
        <h1>
          <Link to={"/admin"}>Admin</Link> -{" "}
          <Link to={"/admin/remote"}>Remote Data</Link> -{" "}
          <Link to={`/admin/remote/${domain.slug}`}>{domain.name}</Link> -{" "}
          <Link to={`/admin/remote/${domain.slug}/${template.slug}`}>
            {template.name}
          </Link>{" "}
          -{" "}
          <Link
            to={`/admin/remote/${domain.slug}/${template.slug}/${source.id}`}
          >
            Source
          </Link>
        </h1>
        <h2>
          <a href={source.url}>{source.url}</a>
        </h2>
        <h1>Pull {pull.id}</h1>
        <Table columns={pullColumns} data={pullData} />
      </>
    );
  }
  return null;
}
